import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import { SellerSession } from '@/server-events/SellerSession';
import {
    setProjectTaskOverview,
    setProjectChangeRequestOverview,
    setProjectCommentsOverview,
} from '@/state/seller/project-overview/actions';
import { SellerChatSession } from '@ygtechnologies/bygr-frontend-chat';
import { getChatConnectionManager } from '@/server-events/connections';
import { useAppDispatch } from '@/utils/hooks';

interface SellerListenerProps { }

const SellerListener: React.FC<SellerListenerProps> = () => {
    const dispatch = useAppDispatch();
    const { activeProfile, activeProject } = useSelector((state: IState) => state.global);

    useEffect(() => {
        if (activeProfile && activeProject) {
            const session = new SellerSession(activeProfile.id, activeProject.id);

            session.addProjectTaskOverviewReceiveHandler((data) => {
                setProjectTaskOverview(dispatch, data);
            });

            session.addProjectChangeRequestOverviewReceiveHandler((data) => {
                setProjectChangeRequestOverview(dispatch, data);
            });

            return function cleanup() {
                session.dispose();
            };
        }
    }, [activeProfile, activeProject, dispatch]);

    useEffect(() => {
        if (activeProfile && activeProject) {
            const session = new SellerChatSession(getChatConnectionManager(), activeProfile.id, activeProject.id);

            session.addReceiveThreadUpdate((data) => {
                setProjectCommentsOverview(dispatch, data);
            });

            return function cleanup() {
                session.dispose();
            };
        }
    }, [activeProfile, activeProject, dispatch]);

    return null;
};

export default SellerListener;
